import { Link, useForm, Head } from '@inertiajs/react';
import React from 'react';
import useRoute from '@/Hooks/useRoute';
import ContainerAuthForm from '@/Components/Containers/ContainerAuthForm';
import Button from '@/Components/Buttons/Button';
import Input from '@/Components/Inputs/Input';
import ValidationErrors from '../../Components/Utility/ValidationErrors';

export default function Register() {
  const route = useRoute();
  const form = useForm({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    terms: false,
  });

  function onSubmit(e) {
    e.preventDefault();
    form.post(route('register'), {
      onFinish: () => form.reset('password', 'password_confirmation'),
    });
  }

  return (
    <ContainerAuthForm>
      <Head title="Register" />

      <ValidationErrors />

      <form onSubmit={onSubmit}>
        <div>
          <Input
            id="name"
            type="text"
            label="Name"
            value={form.data.name}
            onChange={e => form.setData('name', e.currentTarget.value)}
            autoFocus
            autoComplete="name"
            error={form.errors.name}
            required
          />
        </div>

        <div className="mt-2">
          <Input
            id="email"
            type="email"
            label="Email"
            className="mt-1 block w-full"
            value={form.data.email}
            onChange={e => form.setData('email', e.currentTarget.value)}
            error={form.errors.email}
            required
          />
        </div>

        <div className="mt-2">
          <Input
            id="password"
            type="password"
            label="Password"
            className="mt-1 block w-full"
            value={form.data.password}
            onChange={e => form.setData('password', e.currentTarget.value)}
            autoComplete="new-password"
            error={form.errors.password}
            required
          />
        </div>

        <div className="mt-2">
          <Input
            id="password_confirmation"
            type="password"
            label="Confirm Password"
            className="mt-1 block w-full"
            value={form.data.password_confirmation}
            onChange={e =>
              form.setData('password_confirmation', e.currentTarget.value)
            }
            required
            autoComplete="new-password"
          />
        </div>
        <div className="mt-4 flex flex-col items-center justify-between">
          <Button disabled={form.processing} type="submit" style="admin">
            <p className="w-full text-base">Sign Up</p>
          </Button>
          <Link href={route('login')}>
            <Button style="underline">
              <p className="mt-4 text-sm">Login?</p>
            </Button>
          </Link>
        </div>
      </form>
    </ContainerAuthForm>
  );
}
